import { render, staticRenderFns } from "./Item4min.vue?vue&type=template&id=06781204&scoped=true&"
import script from "./Item4min.vue?vue&type=script&lang=js&"
export * from "./Item4min.vue?vue&type=script&lang=js&"
import style0 from "./Item4min.vue?vue&type=style&index=0&id=06781204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06781204",
  null
  
)

export default component.exports